const COMMENTS = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20woman%2C%20warm%20lighting%2C%20neutral%20beige%20background%2C%20soft%20natural%20look%2C%20clean%20minimal%20style&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '小雨',
    movie: '《破墓》',
    text: '好久没看到这么有质感的韩国恐怖片了！金高银的演技真的绝了，氛围营造太到位了，全程屏住呼吸看完的。日韩影视网的画质也很棒，推荐大家都来看看。',
    time: '2小时前',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20man%2C%20warm%20lighting%2C%20neutral%20beige%20background%2C%20clean%20minimal%20style&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '阿杰',
    movie: '《你想活出怎样的人生》',
    text: '宫崎骏老爷子又一部神作！有生之年还能看到新片太幸福了。日韩影视网这么快就有高清资源，必须给个大大的赞，画质音效都很满意。',
    time: '5小时前',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20woman%20smiling%2C%20warm%20lighting%2C%20neutral%20beige%20background%2C%20clean%20minimal%20style&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '喵星人',
    movie: '《犯罪都市4》',
    text: '马东锡的拳头永远不会让人失望！全程高能又爽又好笑，韩国动作片的标杆。感谢日韩影视网第一时间上线高清中字，已经三刷了！',
    time: '8小时前',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20man%20with%20glasses%2C%20warm%20lighting%2C%20neutral%20beige%20background%2C%20clean%20minimal%20style&width=120&height=120&seq=avatar-04&orientation=squarish',
    name: '电影控',
    movie: '《首尔之春》',
    text: '韩国年度票房冠军名不虚传，黄政民和郑雨盛的对手戏看得我头皮发麻。这种级别的韩国电影免费在线观看太难得了，收藏了！',
    time: '12小时前',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">影迷热评</h2>
        <p className="text-sm text-foreground-500 mb-8">看看大家都在讨论哪些日韩电影</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {COMMENTS.map((comment, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-5 border border-background-200/70">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    onError={(e) => { (e.target as HTMLElement).style.display = 'none'; }}
                  />
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <strong className="text-sm font-semibold text-foreground-900">{comment.name}</strong>
                    <span className="text-xs text-accent-600 font-medium">{comment.movie}</span>
                  </div>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{comment.text}</p>
              <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200/70">
                <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" aria-label="Like">
                  <i className="ri-thumb-up-line"></i>
                  <span>{Math.floor(Math.random() * 80 + 20)}</span>
                </button>
                <button className="flex items-center gap-1 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" aria-label="Reply">
                  <i className="ri-chat-1-line"></i>
                  <span>回复</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}